import { createNgReactBridgeDirective } from '../../react-bridge'
import { ResetApplication } from '../../../components/application'

export const resetApplication = createNgReactBridgeDirective(
  'reactResetApplication',
  [],
  ResetApplication,
  ['application', 'appName']
)
